window.askaronUI = window.askaronUI ?? {};

askaronUI.phoneMask = {
  init(elem) {
    if (elem && !elem.askaronPhonemask) {
      elem.askaronPhonemask = new AskaronPhonemask(elem);
    }
  }
};

document.addEventListener('focus', function(e) {
  if (e.target.matches('[data-askr-phone-mask]')) {
    askaronUI.phoneMask.init(e.target);
  }
}, true);
document.addEventListener('input', function(e) {
  if (e.target.matches('[data-askr-phone-mask]')) {
    e.target.setCustomValidity('');
    let value = e.target.value;
    const cleanedPhoneNumber = value.replace(/\D/g, '');
    if (cleanedPhoneNumber.length !== 11) {
      e.target.setCustomValidity('Введите корректный номер телефона');
    }
  }
}, true);
//async, асинхронная загрузка карты
//проверяем что api яндекс карт загружено

askaronUI.asyncMap = {
  timeout: 6000,
  loadMap: async function(options = {}) {
    return new Promise((resolve, reject) => {
      if (askaronUI.asyncMap.isMapApiLoaded()) {
        resolve();
        return;
      }

      if (!options.script) {
        options.script = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
      }

      if ($('script[src^="https://api-maps.yandex.ru/2.1/"]').length < 1) {
        let script = document.createElement('script');
        script.async = true;
        script.src = options.script;
        $('body').append(script);
      }
      let interval = setInterval(function() {
        if (askaronUI.asyncMap.isMapApiLoaded()) {
          clearInterval(interval);
          resolve();
          return;
        }
      }, 100);

      setTimeout(function() {
        clearInterval(interval);
      }, options.timeout ?? askaronUI.asyncMap.timeout);
    
    });
  },
  isMapApiLoaded() {
    if (typeof ymaps == 'undefined' || !ymaps.Map) {
      return false;
    }
    return true;
  }
}
askaronUI.sliders = {
  init: function() {
    this.autoSlider();
  },
  updateFractionElement: function(fractionEl, swiper) {
    if (fractionEl) {
      const current = swiper.realIndex + 1;
      const total = swiper.pagination.bullets.length;
      fractionEl.innerText = `${current} / ${total}`;
      if (total === 1) {
        $(fractionEl).addClass('is-one-slide');
        $(fractionEl).closest('.slider-nav-fraction-block-wrap').addClass('is-hidden');
      } else {
        $(fractionEl).removeClass('is-one-slide');
        $(fractionEl).closest('.slider-nav-fraction-block-wrap').removeClass('is-hidden');
      }
    }
  },
  autoSlider: function() {
    const errors = [];
    $('[data-slider="auto"]').each(function() {
      try {
        if (this.swiper) {
          //prevent reinit
          return;
        }

        let $sliderEl = $(this);
        let sliderContainer = this;

        let sliderContainerTarget = $sliderEl.data('sliderContainer');
        if (sliderContainerTarget !== undefined) {
          sliderContainer = $sliderEl.closest(sliderContainerTarget)[0];
        }

        
        let nextEl = $(sliderContainer).find('[data-slider-auto="nav-next"')[0];
        let prevEl = $(sliderContainer).find('[data-slider-auto="nav-prev"]')[0];
        let paginationEl = $(sliderContainer).find('[data-slider-auto="pagin"]')[0];
        let fractionEl = $(sliderContainer).find('[data-slider-auto="pagin-fraction"]')[0];
        
        //'false' is valid value
        if ($(this).data('sliderNextBtn') !== undefined) 
          nextEl = $($(this).data('sliderNextBtn'))[0];
        if ($(this).data('sliderPrevBtn') !== undefined)
          prevEl = $($(this).data('sliderPrevBtn'))[0];
        if ($(this).data('sliderPagination') !== undefined)
          paginationEl = $($(this).data('sliderPagination'))[0];

        let callback = $(this).data('sliderInitCallback');
        
        let options = {
          init: false,
          slidesPerView: 'auto',
          watchSlidesProgress: true,
          simulateTouch: true,
          navigation: {
            nextEl,
            prevEl,
          },
          "pagination": { 
            el: paginationEl, 
            type: $sliderEl.data('sliderPaginationType') ?? "bullets", 
            clickable: true
          },
          on: {
            init(swiper) {
              try {
                if (callback) {
                  window[callback](swiper);
                }
              } catch(e) {
                console.error(e);
              }
              askaronUI.sliders.updateFractionElement(fractionEl, swiper);
            },
            slideChange: function (swiper) {
              askaronUI.sliders.updateFractionElement(fractionEl, swiper);
            },
            update: function (s) {
              askaronUI.sliders.updateFractionElement(fractionEl, swiper);
            }
          }
        };
  
        if ($sliderEl.data('sliderOptions')) {
          let localOptions = {};
          if ($sliderEl.data('sliderOptions')) {
            localOptions = $sliderEl.data('sliderOptions');
            if (typeof(localOptions) != 'object') {
              localOptions = JSON.parse(localOptions);
            }
          }
          options  = Object.assign(options, localOptions);
        }
        
        let swiper =  new Swiper(this, options);
        swiper.init();
        

      } catch(err) {
        errors.push(err);
      }
    });
    if (errors.length > 0) {
      console.warn('autoSlider init errors!')
      errors.forEach((err) => {
        throw err;
      });
    }
  },
};
askaronUI.responsiveBlock = {
  lastViewport: 'mobile',
  setPosition: function() {
    let viewport = 'desktop';
    if (window.innerWidth < 1200) {
      viewport = 'mobile';
    }
    if (askaronUI.responsiveBlock.lastViewport === viewport) {
      return; // No change in viewport
    }
    askaronUI.responsiveBlock.lastViewport = viewport;
    $blocks = $('[data-askr-position-block]');
    $blocks.each(function() {
      let id = $(this).data('askrBlockId');
      let blockViewport = $(this).data('askrPositionBlock');
      if (!id || !blockViewport) {
        console.warn('Block position data missing:', this);
        return;
      }
      if (blockViewport === viewport) {
        //nothing to do
      }
      else {
        const $content = $(this).children();
        const $target = $(`[data-askr-block-id="${id}"][data-askr-position-block="${viewport}"]`);
        if ($target.length) {
          $content.appendTo($target);
        }
      }
    });
  }
}
askaronUI.tabs = {
  init: function() {
    $(document).off('click.askr.tabs');
    $(document).on('click.askr.tabs', '[data-toggle="tab"]', function(event) {
      event.preventDefault();
      console.log('test');
      let target = $(this).data('tabTarget') ?? $(this).attr('href');
      if (!target) {
        throw new Error("No target provided for tab");
      }
      let group = $(this).data('tabGroup');
      if (!group) {
        group = $(target).data('tabGroup');
      }
      $('[data-toggle="tab"][data-tab-group="'+group+'"]').removeClass('active');
      if (group) {
        $(this).addClass('active');
        $('.collapse[data-tab-group="'+group+'"]').removeClass('show');
      }
      $(target).addClass('show');
    });
  },
};
askaronUI.datepicker = {
  locales: {
    ru: {
      weekdays: {
        shorthand: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        longhand: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']
      },
      months: {
        shorthand: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
      },
      daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      firstDayOfWeek: 1,
      ordinal: (nth) => {
        const s = nth % 100;
        if (s > 3 && s < 21) return 'й';
        switch (s % 10) {
          case 1: return 'й';
          case 2: return 'ой';
          case 3: return 'ий';
          case 4: return 'ый';
          default: return 'й';
        }
      },
      rangeSeparator: ' - ',
      weekAbbreviation: 'Нед',
      scrollTitle: 'Прокрутите для увеличения',
      toggleTitle: 'Нажмите для переключения',
      amPM: ['ДП', 'ПП'],
      yearAriaLabel: 'Год',
      monthAriaLabel: 'Месяц'
    }
  },
  getDefaultOptions: () => {
    return {
      useMask: true,
      readonly: true,
      locale: 'ru',
      dateFormat: 'd.m.Y',
      allowInput: true,
      clickOpens: true,
      altInput: false,
      disableMobile: true,
    };
  },
  init: function(selector = null, initOptions = {}) {
    
    let returnPicker = ($(selector).length === 1);
    
    $(selector).each(function() {
      
      let options = askaronUI.datepicker.getDefaultOptions();

      options  = Object.assign(options, initOptions);
      let localOptions = {};

      //в safari не работает выбор месяца если дейтпикер не в модальном окне
      let $modal = $(this).closest('.modal');
      let $container = $(this).closest('.form-floating');
      if ($modal.length && $container.length) {
        localOptions.appendTo = $container[0];
      }
    
      if ($(this).data('askrDatepickerOptions')) {
        if ($(this).data('askrDatepickerOptions')) {
          localOptions = $(this).data('askrDatepickerOptions');
          if (typeof(localOptions) != 'object') {
            localOptions = JSON.parse(localOptions);
          }
        }
      }
      options  = Object.assign(options, localOptions);
    
      // Устанавливаем русскую локаль
      if (typeof flatpickr !== 'undefined' && flatpickr.l10ns && flatpickr.l10ns.ru) {
        flatpickr.localize(flatpickr.l10ns.ru);
      }
      
      const datepicker = flatpickr(this, options);
      this.datepicker = datepicker;
      if ($.jMaskGlobals && options.useMask !== false) {
        $(this).mask('00.00.0000', {autoclear: false});
      }
      if (options.readonly === true) {
        $(this).attr('readonly', true);
      }
      if (returnPicker) {
        returnPicker = datepicker;
      }
    });

    return returnPicker;
  },
}
$(document).on('change.askrFileinput', '[data-askr-file="input"]', function() {
  let $input = $(this);
  let $container = $(this).closest('[data-askr-file="container"]');
  let $textTarget = $container.find('[data-askr-file="text-target"]');
  let $fileLabel = $container.find('[data-askr-file="file-label"]');
  
  let fileList = this.files;
  
  if ($container.length < 1) {
    throw new Error('[data-askr-file="container"]');
  }
  if ($textTarget.length < 1) {
    throw new Error('[data-askr-file="text-target"]');
  }
  $textTarget.each(function() {
    if (!this.defaultText)
      this.defaultText = this.textContent;
  })
  if (fileList && fileList.length) {
    let fileNames = Array.from(fileList).map(file => `<div>${file.name};</div>`).join('');
    $textTarget.html(fileNames);
    if ($fileLabel.length) {
      if (fileList.length > 1)
        $fileLabel.text('Выбраны файлы');
      else
        $fileLabel.text('Выбран файл');
    }

  }
  else {
    $textTarget.each(function() {
      this.textContent = this.defaultText;
    });
    if ($fileLabel.length) {
      $fileLabel.text('Выбран файл');
    }
  }

  askaronUI.uploadInput.renderUpdate($input);
});

$(document).on('click.askrFileinput.clear', '[data-askr-file="clear"]', function() {
  let $container  = $(this).closest('[data-askr-file="container"]');
  let $input      = $container.find('[data-askr-file="input"]');
  let $textTarget = $container.find('[data-askr-file="text-target"]');
  let $fileLabel  = $container.find('[data-askr-file="file-label"]');

  $input.val(''); 

  $textTarget.each(function() {
    if (this.defaultText)
      this.textContent = this.defaultText;
  });

  if ($fileLabel.length) {
    $fileLabel.text('Выбран файл');
  }
  askaronUI.uploadInput.renderUpdate($input);
});

askaronUI = askaronUI || {};

askaronUI.uploadInput = {
  renderUpdate(elem = '[data-askr-file="input"]') {
    $(elem).each(function() {
      let fileList = this.files;
      let hasFiles = fileList && fileList.length;
      let $container  = $(this).closest('[data-askr-file="container"]');
      askaronUI.uploadInput._renderClearButton($container, hasFiles);
    });  
  },
  _renderClearButton($container, hasFiles) {
    let $clearBtn = $container.find('[data-askr-file="clear"]');
  
    if (hasFiles) {
      if (!$clearBtn.length) {
        $clearBtn = $('<button type="button" class="b-file-upload__clear" data-askr-file="clear">Удалить</button>');
        $container.find('.b-file-upload__info').append($clearBtn);
      }
    } else {
      if ($clearBtn.length) {
        $clearBtn.remove();
      }
    }
  }
}
$(document).ready(function() {
  var $tocLinks = $('.js-table-of-contents .b-toc__list a');
  var $sections = $tocLinks.map(function() {
    var id = $(this).attr('href');
    return $(id).length ? $(id) : null;
  });

  $(window).on('scroll', function() {
    var scrollPos = $(window)[0].scrollY + 300;
    var currentSection = null;

    $sections.each(function() {
      if ($(this).offset().top <= scrollPos) {
        currentSection = this[0];
      }
    });

    $tocLinks.removeClass('active');
    if (currentSection) {
      $tocLinks.each(function() {
        if ($(this).attr('href') === '#' + currentSection.id) {
          $(this).addClass('active');
        }
      });
    }
  });
});
/**
 * Sets focus on not visible at moment inputs. Including ios devices.
 * 
 * @param {*} el 
 * @param {*} delay 
 */
askaronUI.focusKeyboard = function(el, delay = 100) {
  try {
    if (typeof el != 'string' && !(el instanceof HTMLElement)) {
      throw new Error('askaronUI.focusKeyboard: el must be a string selector or HTMLElement');
    }
    if (typeof el === 'string') {
      el = document.querySelector(el);
    }
    const fakeInput = document.createElement('input');
    fakeInput.setAttribute('type', 'text');
    fakeInput.style.position = 'absolute';
    fakeInput.style.opacity = '0.1001'; //2021 iOS 15
    fakeInput.style.height = '0';
    fakeInput.style.fontSize = '16px'; // disable auto zoom
    
    el.after(fakeInput);
    fakeInput.focus();
    
    setTimeout(() => {
      el.focus();
      fakeInput.remove();
    }, delay);

  } catch (e) {
    console.error('Error focusing element:', e);
  }
};

(function($) {
    $.fn.hasOverflow = function() {
        var el = this[0];
        if (!el) return false;
        
        return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
    };
})(jQuery);

askaronUI.tabs.init();


$(document).on('mouseover pointerdown', '[data-askr-datepicker="auto"]', function() {
  if ($(this).hasClass('datepicker-inited')) {
    return;
  }
  askaronUI.datepicker.init(this);
  $(this).addClass('datepicker-inited');
});


askaronUI.phoneMask = {
  init(elem) {
    if (elem && !elem.askaronPhonemask) {
      elem.askaronPhonemask = new AskaronPhonemask(elem);
    }
  }
};

askaronUI.toggleReviewBtn = function() {
  const $reviewsCardBtns = $('.b-review-card .js-review-more-btn');
  $reviewsCardBtns.each(function() {
    const $card = $(this).closest('.b-review-card');
    const $text = $card.find('.card-text');
    $(this).addClass('inited');
    if ($text.hasOverflow()) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
}

$(document).ready(function() {

  setTimeout(() => {
    askaronUI.sliders.init();
  }, 0);

  
  let resizeTimeout;
  $(window).on('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      askaronUI.responsiveBlock.setPosition();
      askaronUI.toggleReviewBtn();
    }, 200);
  });
  askaronUI.responsiveBlock.setPosition();
  askaronUI.toggleReviewBtn();


  let rootStyles = window.getComputedStyle(document.documentElement);
  let breakpoints = new Map();
  for (let i = 0; i < rootStyles.length; i++) {
      let prop = rootStyles[i];
      if (prop.startsWith('--breakpoint-')) {
          let value = rootStyles.getPropertyValue(prop).trim();
          value = value.replace('px', '');
          let label = prop.replace('--breakpoint-', '');
          breakpoints.set(label, Number(value));
      }
  }
  breakpoints = new Map([...breakpoints.entries()].sort((a,b) => a[1] - b[1]))
  askaronUI.breakpoints = {
    list: breakpoints,
    getCurrent() {
      let width = window.innerWidth;
      let breakpoint = {};
      askaronUI.breakpoints.list.forEach((value, key) => {
        if (width >= value) {
          breakpoint = {
            name: key,
            value: value
          }
        }
      });
      return breakpoint;
    },
  };



  $(document).on('click', '[data-toggle="mobile-menu"]', function() {
    $('body').toggleClass('body-mobile-menu-open');
    $('.mobile-menu').toggleClass('show');
  });



  $(document).on('mouseenter touchstart', '.accordion-button a', function(event) {
    let $button = $(this).closest('.accordion-button');
    $button.attr('data-bs-toggle', 'collapse-link-enter')
  });
  $(document).on('mouseleave touchend', '.accordion-button a', function(event) {
    let $button = $(this).closest('.accordion-button');
    $button.attr('data-bs-toggle', 'collapse')
  });
  $(document).on('mouseenter', '.accordion-button[data-bs-toggle="collapse-link-enter"]', function(event) {
    $(this).attr('data-bs-toggle', 'collapse')
  });


  $('[data-askr-phone-mask]').each(function() {
    askaronUI.phoneMask.init(this);
  });

  $(document).on('focus', '[data-askr-phone-mask]', function() {
    if (this.matches('[data-askr-phone-mask]')) {
      askaronUI.phoneMask.init(this);
    }
  });

  // Initialize datepickers
  $('[data-askr-datepicker="auto"]').each(function() {
    if (!$(this).hasClass('datepicker-inited')) {
      askaronUI.datepicker.init(this);
      $(this).addClass('datepicker-inited');
    }
  });

});


$(document).on('click', '.js-footer-nav .footer-nav-top', function() {
  if (window.innerWidth > 1023) {
    return;
  }
  $(this).toggleClass('open');
  $(this).next('.footer-nav-inner').slideToggle('open');
});


$(document).ready(function() {

  $('.js-promo-slider').each(function() {
    let elem = this;
    let fractionEl = $(this).find('.slider-pagin-fraction')[0];
    let swiper = new Swiper(elem, {
      init: false,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      simulateTouch: true,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: $(this).find('.slider-nav-btn-next')[0],
        prevEl: $(this).find('.slider-nav-btn-prev')[0],
      },
      pagination: {
        el: $(this).find('.swiper-pagination')[0],
        type: 'bullets', // Default type
      },
      on: {
        init: function(swiper) {
          askaronUI.sliders.updateFractionElement(fractionEl, swiper);
        },
        slideChange: function (swiper) {
          askaronUI.sliders.updateFractionElement(fractionEl, swiper);
        },
        autoplayTimeLeft: function(swiper, time, progress) {
          $(swiper.el).css('--slide-progress', `${progress * -100}%`);
        },
      },
    });
    swiper.init();
  })

  $('.js-articles-slider').each(function() {
    let elem = $(this).find('.swiper')[0];
    let fractionEl = $(this).find('.slider-pagin-fraction')[0];
    let swiper = new Swiper(elem, {
      init: false,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      simulateTouch: true,
      navigation: {
        nextEl: $(this).find('.slider-nav-btn-next')[0],
        prevEl: $(this).find('.slider-nav-btn-prev')[0],
      },
      pagination: {
        el: $(this).find('.swiper-pagination')[0],
        type: 'bullets', // Default type
      },
      on: {
        init: function(swiper) {
          askaronUI.sliders.updateFractionElement(fractionEl, swiper);
        },
        slideChange: function (swiper) {
          askaronUI.sliders.updateFractionElement(fractionEl, swiper);
        },
        autoplayTimeLeft: function(swiper, time, progress) {
          $(swiper.el).css('--slide-progress', `${progress * -100}%`);
        },
      },
    });
    swiper.init();
  });

  function initEventsSlider() {
    $('.js-events-slider').each(function() {
      const $container = $(this);
      const $slider = $container.find('.swiper');
      const fractionEl = $container.find('.slider-pagin-fraction')[0];
      let swiperInstance = null;

      function toggleSwiper() {
        const isDesktop = window.innerWidth > 1024;

        if (isDesktop && !swiperInstance) {
          // Инициализация, если больше 1024 и еще не создан
          swiperInstance = new Swiper($slider[0], {
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            pagination: {
              el: $('.js-events-slider .slider-pagin-bullets')[0],
              type: 'bullets', // Default type
            },
            navigation: {
              nextEl: $container.find('.slider-nav-btn-next')[0],
              prevEl: $container.find('.slider-nav-btn-prev')[0],
            },
            on: {
              init: function(swiper) {
                askaronUI.sliders.updateFractionElement(fractionEl, swiper);
              },
              slideChange: function(swiper) {
                askaronUI.sliders.updateFractionElement(fractionEl, swiper);
              },
            }
          });
        } else if (!isDesktop && swiperInstance) {
          // Уничтожение, если меньше 1024 и слайдер существует
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }

      // Запуск при загрузке и ресайзе
      toggleSwiper();
      $(window).on('resize', debounce(toggleSwiper, 150));
    });
  }
  initEventsSlider();

  // Вспомогательная функция, чтобы не спамить ресайзом
  function debounce(func, wait) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, arguments), wait);
    };
  }


  $('.js-home-main-slider').each(function() {
    let elem = $(this).find('.swiper')[0];
    let fractionEl = $(this).find('.slider-pagin-fraction')[0];
    let swiper = new Swiper(elem, {
      init: false,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      simulateTouch: true,
      navigation: {
        nextEl: $(this).find('.slider-nav-btn-next')[0],
        prevEl: $(this).find('.slider-nav-btn-prev')[0],
      },
      pagination: {
        el: $(this).find('.home-main-slider__pagin')[0],
        type: 'bullets', // Default type
        dynamicBullets: true,
      },
      on: {
        init: function(swiper) {
          askaronUI.sliders.updateFractionElement(fractionEl, swiper);
        },
        slideChange: function(swiper) {
          askaronUI.sliders.updateFractionElement(fractionEl, swiper);
        },
      },
    });
    swiper.init();
  });

  if (window.innerWidth > 1780) {
    $('.js-b-contact-card .card-collapse-toggle').attr('data-bs-toggle', false);
  }


  $(document).on('focus', '.js-search-control-group .form-search__input', function() {
    $(this).closest('.form-search-wrap').addClass('is-active');
  });
  $(document).on('blur', '.js-search-control-group .form-search__input', function() {
    if ($(this).val() === '') {
      $(this).closest('.form-search-wrap').removeClass('is-active');
    }
  });
  $(document).on('click', '.js-search-control-group .form-search-reset', function() {
    $(this).closest('.form-search-wrap').removeClass('is-active');
    $(this).closest('.form-search-wrap').find('.form-search__input').val('');
  });


  //-------
  //fix toc block in blog
  const $tocBlock = $('.js-mobile-toc');
  const $tocScrollTrigger = $('#tocScrollTrigger');

  $(window).on('scroll', function() {
    if ($tocScrollTrigger.length === 0) return;
    
    const triggerTop = $tocScrollTrigger.offset().top;
    const scrollTop = $(window).scrollTop();
    
    if (scrollTop >= triggerTop) {
      $tocBlock.addClass('is-fixed');
    } else {
      $tocBlock.removeClass('is-fixed');
    }
  });

  //-------
  //toggle mobile toc in blog
  $(document).on('click', '.js-mobile-toc-dropdown', function() {
    $('.p-article-toc').toggleClass('is-display-all');
    $('.p-blog-toc-backdrop').toggleClass('show');
  });
  $(document).on('click', '.is-display-all .p-article-toc__title, .is-display-all a', function() {
    $('.p-article-toc').toggleClass('is-display-all');
    $('.p-blog-toc-backdrop').toggleClass('show');
  });

  $(document).on('click', '.b-age-overlay', function() {
    $('.b-age-overlay').addClass('fading');
    setTimeout(() => {
      $('.b-age-overlay').hide();
      $('[data-age-restricted]').data('age-restricted', false);
      const lbSwiper = $('.lightbox-swiper-modal .swiper')[0]?.swiper
      if (lbSwiper) {
        const newSlides = lbSwiper.virtual.slides.map((element) => {
            element.ageRestricted = false;
            return element;
        });
        lbSwiper.virtual.slides = newSlides;
        lbSwiper.virtual.cache = {};
        lbSwiper.virtual.update();
      }
    }, 150);
  });

  $(document).on('pointerover', '.b-doctor-card', function() {
    $(this).addClass('is-hover');
    let height = $(this).outerHeight();
    $(this).css('--init-height', height + 'px');
    $(this).addClass('is-transition-in');
    setTimeout(() => {
      $(this).removeClass('is-transition-in');
    }, 400);
  });
  $(document).on('pointerleave', '.b-doctor-card', function() {
    $(this).removeClass('is-hover');
    $(this).addClass('is-transition-out');
    setTimeout(() => {
      $(this).removeClass('is-transition-out');
      if ($(this).hasClass('is-hover')) {
        return;
      }
      $(this).css('--init-height', '');
    }, 400);
  });


});